import styles from './Stepper.module.css';

/**
 * The numbered progress trail across the top of the forecast wizard.
 *
 * steps:   ['Sport', 'Date', 'League', 'Match', 'Forecast']
 * current: 1-based index of the active step
 * onStepClick: optional — lets the user jump back to a completed step
 */
export function Stepper({ steps, current = 1, onStepClick, className = '' }) {
  return (
    <ol className={`${styles.stepper} ${className}`}>
      {steps.map((label, i) => {
        const n = i + 1;
        const state = n === current ? 'on' : n < current ? 'done' : '';
        const canClick = Boolean(onStepClick) && n < current;

        return (
          <li key={label} className={styles.item}>
            <button
              type="button"
              className={`${styles.st} ${styles[state] || ''}`}
              disabled={!canClick}
              aria-current={n === current ? 'step' : undefined}
              onClick={() => canClick && onStepClick(n)}
            >
              <span className={styles.num}>{n}</span>
              <span className={styles.text}>{label}</span>
            </button>
            {n < steps.length && (
              <span className={styles.sep} aria-hidden="true">
                ›
              </span>
            )}
          </li>
        );
      })}
    </ol>
  );
}
